import API from '../../../../API/API'
import { asArray, asText, authHeaders, toSelectOptions } from '../Shared/apiHelpers'

/**
 * Both warehouse lists are keyed by targetId, including the ERP one - that matches
 * the live endpoints, so do not swap in sourceId here.
 *
 * Each entry is { name, value }: `value` is the location id, `name` is the label
 * shown to users. The mapping stores both.
 */
const warehouseUrl = (system, instancesId, targetId) => `/Warehouse/${system}/${instancesId}/${targetId}`

const mappingsUrl = (connectorId, instancesId) =>
    `/Connection/${connectorId}/instance/${instancesId}/location-mappings`

export const getErpLocations = (instancesId, targetId, config) =>
    API.get(warehouseUrl('erp', instancesId, targetId), { headers: authHeaders(), ...config })
        .then((response) => toSelectOptions(response.data))

export const getEcommerceLocations = (instancesId, targetId, config) =>
    API.get(warehouseUrl('ecommerce', instancesId, targetId), { headers: authHeaders(), ...config })
        .then((response) => toSelectOptions(response.data))

export const getLocationMappings = (connectorId, instancesId, config) =>
    API.get(mappingsUrl(connectorId, instancesId), { headers: authHeaders(), ...config })
        .then((response) => asArray(response.data).map((mapping) => ({
            erpLocationId: asText(mapping.erpLocationId),
            erpMethod: asText(mapping.erpMethod),
            ecommerceLocationId: asText(mapping.ecommerceLocationId),
            ecommerceMethod: asText(mapping.ecommerceMethod),
            isDefault: Boolean(mapping.isDefault)
        })))

/**
 * Payload shape expected by POST .../location-mappings. Note the PascalCase keys -
 * the GET returns camelCase but the POST does not accept it. isEcommerceDefault and
 * isErpDefault were hard-coded false in the original screen and are kept that way;
 * the API contract for them is still unconfirmed.
 */
const toRequestBody = (mapping) => ({
    IsDefault: mapping.isDefault,
    EcommerceMethod: mapping.ecommerceMethod,
    ErpMethod: mapping.erpMethod,
    ErpLocationId: mapping.erpLocationId,
    EcommerceLocationId: mapping.ecommerceLocationId,
    isEcommerceDefault: false,
    isErpDefault: false
})

export const saveLocationMappings = (connectorId, instancesId, mappings) =>
    API.post(mappingsUrl(connectorId, instancesId), mappings.map(toRequestBody), { headers: authHeaders() })
        .then((response) => response.data)
